module.exports = __webpack_public_path__ + "img/gaoya65535.f3887577.svg";